import useTasks from '@/hooks/useTasks.ts';

import { GenericPatient } from '@/models/GenericPatient.ts';
import { EnrichedTask } from '@/models/doc-cirrus/DCTask.ts';

import { getPatientTasks } from '@/utils/task-utils.ts';

interface PatientTasksHook {
    tasks: EnrichedTask[];
    isLoading: boolean;
    mutate: () => void;
}

export const usePatientTasks = (patient: GenericPatient | undefined): PatientTasksHook => {
    const { open_tasks: openTasks, is_loading_open: isLoadingOpen, mutateOpenTasks } = useTasks();

    const tasks = patient ? getPatientTasks(openTasks, patient) : [];

    return {
        tasks: tasks,
        isLoading: isLoadingOpen,
        mutate: mutateOpenTasks,
    };
};
